import { createContext, useState } from "react";

type Theme = "light" | "dark";

export const ThemeContext = createContext<[Theme, React.Dispatch<React.SetStateAction<Theme>>]>(["light", () => {}]);

export const ThemeProvider = ({ children }: { children: React.ReactNode }) => {
    const [theme, setTheme] = useState<Theme>("light");
    return (
        <ThemeContext.Provider value={[theme, setTheme]}>
            {children}
        </ThemeContext.Provider>
    );
};


